import { Controller } from "@hotwired/stimulus"

/**
 * Sidebar logo dropdown. Click the logo to reveal the list of
 * companies the current admin belongs to; click again or anywhere
 * outside, or hit Escape, to close.
 */
export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    this._onDocClick = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
    this._onKey = (e) => {
      if (e.key === "Escape") this.close()
    }
    document.addEventListener("click", this._onDocClick)
    document.addEventListener("keydown", this._onKey)
  }

  disconnect() {
    document.removeEventListener("click", this._onDocClick)
    document.removeEventListener("keydown", this._onKey)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.menuTarget.classList.contains("hidden")) this.open()
    else this.close()
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.menuTarget.classList.add("hidden")
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", "false")
  }
}
